import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Avatar from "@mui/material/Avatar";
import axios from "../utils/fvAxios";
import apiinfo from "../utils/base-uri.json";
import { getisEmp, HasScreenPermissions } from "../utils/Token";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Logo from "../toolkit/Logo";
import FormControl from "./FormControl";
import { getOrgType, setGlobalClientId } from "../utils/Token";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import React, { useState, useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { Card, TextField, Checkbox, Chip } from '@mui/material';
import Stack from '@mui/material/Stack';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import InputAdornment from "@mui/material/InputAdornment";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import { getUserName, getEmail, getIncognitoEmail } from "../utils/Token";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import SearchIcon from "../icons/SearchIcon";
import { useNavigate } from "react-router-dom";
import { styled } from '@mui/material/styles';
import GavelIcon from '@mui/icons-material/Gavel';
import ChatIcon from "../icons/ChatIcon";
import UserPlus from "../icons/UserPlus";
import HelpIcon from "../icons/HelpIcon";
import { useTranslation } from "react-i18next";
import "../Localization/i18n";


export default function LargeScreen({
  items = [],
  icons,
  userSettings,
  handleOpenUserMenu,
  handleCloseUserMenu,
  anchorElUser,
  value: selected,
  handleSubMenuClick,
  switchToIncognitoUser
}) {
  const name = getUserName()
  const email = getEmail()
  const incognitoEmail = getIncognitoEmail() ?? "";
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [ser1, setSer1] = useState("");
  const [ser, setSer] = useState("");
  const [searchParam] = useState(["text"]);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))`
    & .MuiTooltip-tooltip {
      background:  rgba(97, 97, 97, 0.92)!important;
      color:#fff !important
    }
       & .MuiTooltip-arrow: {
      color: rgba(97, 97, 97, 0.92)!important;
    }
  `;
  const handleClose = () => {
    setOpen(false);
    setSer1("");
    setSer("");
    setClients(actualclients.map(r => ({ value: r.value, text: r.text, selected: r.selected })))
  };
  const [clients, setClients] = useState([]);
  const [actualclients, setActualClients] = useState([]);
  const handleToggle = (e) => () => {
    e.selected = true;
    let newArr = [...clients]
    newArr.find(r => r.value === e.value).selected = true;
    setClients(newArr);
  };
  useEffect(() => {
    axios.get(apiinfo.Clients.GetAllClients + "getAll=true")
      .then(res => {
        if (res.data.status === true) {
          setClients(res.data.data);
          setActualClients(res.data.data.map(r => ({ value: r.value, text: r.text, selected: r.selected })));
        }
        else {
          alert(res.data.responseMessage);
        }
      }).catch(err => {
        console.log(err)
      })
  }, []);
  const navigate = useNavigate();
  const { t } = useTranslation();

  function handleSelectChange() {
    const data = clients.filter(r => r.selected)
    const ids = data.map(r => r.value)
    axios.post(apiinfo.Clients.SaveGlobalClient + "clientIds=" + ids)
      .then(response => {
        if (response.data.status === true) {
          setGlobalClientId(ids);
          window.location.reload();
        }
        else {
          alert("Please select the client");
        }
      })
  }
  const handleDelete = (event, e) => {
    e.selected = false;
    let newArr = [...clients]
    newArr.find(r => r.value === e.value).selected = false;
    setClients(newArr);
  };
  const data = actualclients.filter(r => r.selected);
  const clientNames = data.map(r => r.text);

  const IconTextField = ({ iconStart, iconEnd, InputProps, ...props }) => {

    const globalclient = clientNames.slice(1);
    const globalclient1 = globalclient.join(" | ");


    return (
      <TextField
        size="small"
        value={clientNames[Math.floor(0)]}
        sx={{
          "& legend": { display: "none" },
          "& fieldset": { top: 0 },
          "& .MuiInputBase-input": {
            overflow: "hidden",
            textOverflow: "ellipsis",
            cursor: "pointer"
          },
          cursor: "pointer"
        }}
        onClick={handleClickOpen}
        {...props}
        InputProps={{

          ...InputProps,
          readOnly: true,
          endAdornment: iconEnd ? (
            <>
              <InputAdornment position="end" style={{ cursor: "pointer" }}>
                <Tooltip title={globalclient1} arrow >
                  <span style={{ display: clientNames.length === 1 ? "none" : "block", cursor: "pointer" }}>+{clientNames.length > 1 ? clientNames.length + 1 - 2 : ""} Client(s)</span>
                </Tooltip>
              </InputAdornment>
              <InputAdornment position="end" style={{ cursor: "pointer" }} >{iconEnd}</InputAdornment>
            </>
          ) : null
        }}
      />
    );
  };

  const handleSelectAll = () => {
    let newArr = [...clients];
    newArr.map((r) => (r.selected = true));
    setClients(newArr);

  };

  const handleRemoveSelected = () => {
    let newArr = [...clients];
    newArr.map((r) => (r.selected = false));
    setClients(newArr);

  };

  function search(clients) {
    return clients.filter((item) => {
      return searchParam.some((newItem) => {
        return (
          item[newItem]
            .toString()
            .toLowerCase()
            .indexOf(ser1.toLowerCase()) > -1
        );
      });
    });
  }
  function searchright(clients) {
    return clients.filter((item) => {
      return searchParam.some((newItem) => {
        return (
          item[newItem]
            .toString()
            .toLowerCase()
            .indexOf(ser.toLowerCase()) > -1
        );
      });
    });
  }
  const ITEM_HEIGHT = 50;
  const [anchorEl, setAnchorEl] = useState(null);
  const open1 = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl(null);
  };
  return (
    <Toolbar disableGutters sx={{ display: "flex" }}>
      <Logo variant="h5" />

      {incognitoEmail !== "" &&
        <Box sx={{ flexGrow: 0, marginLeft: "10px" }}>
          <a onClick={switchToIncognitoUser} variant="outlined" style={{ color: "rgb(97, 169, 251)", cursor: "pointer" }}>Switch to - {incognitoEmail}</a>
        </Box>
      }

      <Box sx={{ flexGrow: 1, display: "flex" }} />
      {getOrgType() == "Admin" &&
        <IconTextField iconEnd={<ArrowDropDownIcon sx={{ fontSize: 18 }} />} />
      }
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "700px",
            },
          },
        }}

      >
        <DialogTitle sx={{ marginTop: 1, backgroundColor: " rgb(243, 246, 249)" }} id="responsive-dialog-title">
          {"Global Client Selection"}
        </DialogTitle>
        <DialogContent sx={{ overflowY: "hidden", backgroundColor: " rgb(243, 246, 249)", }} >
          {/* <DialogContentText sx={{ overflowY: "hidden", backgroundColor: " rgb(243, 246, 249)", marginBottom: 1 }}> */}
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={6} md={6}>
                <TextField placeholder="Search..." sx={{ "& legend": { display: "none" }, "& fieldset": { top: 0 }, width: "310px" }} variant="outlined" size="small" value={ser1} onChange={(e) => setSer1(e.target.value)} />
                <Box tag={"div"} sx={{
                  padding: 1,
                  marginTop: 1,
                  overflowY: "auto",
                  maxHeight: "230px",
                  height: "230px",
                  width: "310px",
                  marginBottom: 1,
                  backgroundColor: "#fff",
                }}>
                  <List dense sx={{ width: '100%', maxWidth: 360 }}>
                    <a onClick={handleSelectAll} style={{ float: "right", color: "#0d6efd", cursor: "pointer", fontSize: "12px", textDecoration: "none" }} > Add All <KeyboardDoubleArrowRightIcon /> </a>

                    {search(clients).filter(r => r.selected === false).map((r) => {
                      const labelId = `checkbox-list-secondary-label-${r.text}`;
                      return (

                        <ListItem
                          key={r.value}
                          style={{ color: "rgba(0, 0, 0, 0.87)", fontSize: "10px" }}
                          disablePadding
                          secondaryAction={
                            <>
                              <IconButton onClick={handleToggle(r)}>
                                <AddCircleIcon />
                              </IconButton>
                            </>
                          }
                        >
                          <ListItemButton dense>
                            <ListItemText id={labelId} primary={r.text} />
                          </ListItemButton>
                        </ListItem>

                      );
                    })}
                  </List>

                </Box>
              </Grid>
              <Grid item xs={6} md={6} >
                <TextField id="outlined-basic" sx={{ width: "310px" }} placeholder="Search..." variant="outlined" size="small" value={ser} onChange={(e) => setSer(e.target.value)} />
                <Box sx={{
                  padding: 1,
                  marginTop: 1,
                  overflowY: "auto",
                  maxHeight: "230px",
                  height: "230px",
                  width: "310px",
                  marginBottom: 1,
                  backgroundColor: "#fff",
                }}>
                  <List dense sx={{ width: '100%', maxWidth: 360 }} >
                    <a onClick={handleRemoveSelected} style={{ float: "left", color: "#0d6efd", cursor: "pointer", fontSize: "12px", textDecoration: "none" }} > <KeyboardDoubleArrowLeftIcon /> Remove All</a>
                    <br />
                    {searchright(clients).filter(r => r.selected === true).map((r) => {
                      const labelId = r.text;
                      return (

                        <Chip key={r.value} label={labelId} onDelete={(e) => handleDelete(e, r)} sx={{ marginTop: 1 }} />

                      );
                    })}
                  </List>

                </Box>
              </Grid>
            </Grid>
          </Box>
          {/* </DialogContentText> */}

          <Stack direction="row" spacing={1} sx={{ float: "right", marginTop: "10px" }}>
            <Button variant="contained" onClick={handleSelectChange} sx={{ height: "30px", width: "88px" }}>Save</Button>
            <Button variant="outlined" onClick={handleClose} sx={{ height: "30px" }}>Cancel</Button>
          </Stack>

        </DialogContent>


      </Dialog>
      <Box sx={{ display: "flex", marginLeft: "15px" }}>
        <span hidden={getOrgType() == "Vendor"} className="mx-1" style={{ display: "flex", justifyContent: "center", alignContent: "center", justifyItems: "center", cursor: "pointer" }} onClick={() => navigate("/VendorSearch")}>

          <SearchIcon width="1.25rem" /></span>
        <span hidden={getOrgType() == "Vendor"} className="mx-1" style={{ display: "flex", justifyContent: "center", alignContent: "center", justifyItems: "center", cursor: "pointer" }} onClick={() => navigate("/InviteVendor")}>

          <UserPlus width="1.25rem" /></span>
        {/* <span className="mx-1" id="long-button"
          aria-controls={open1 ? "long-menu" : undefined}
          aria-expanded={open1 ? "true" : undefined}
          aria-haspopup="true" style={{ display: "flex", justifyContent: "center", alignContent: "center", justifyItems: "center", cursor: "pointer" }} onClick={handleClick}>

          <HelpIcon width="1.25rem" /></span> */}

        <Menu
          id="long-menu"
          MenuListProps={{
            "aria-labelledby": "long-button",
          }}
          anchorEl={anchorEl}
          open={open1}
          onClose={handleClose1}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: "20ch",
            },
          }}
        >
          <MenuItem onClick={handleClose1}>
            <a style={{ textDecoration: "none", cursor: 'pointer', color: "black" }} href="/terms_and_conditions" target="blank">
              Terms and Conditions
            </a>
          </MenuItem>

          <MenuItem onClick={handleClose1}>
            <a style={{ textDecoration: "none", cursor: 'pointer', color: "black" }} href="/Statement_of_Privacy" target="blank">
              Statement of Privacy                            </a>
          </MenuItem>
          <MenuItem onClick={handleClose1}>
            <a style={{ textDecoration: "none", cursor: 'pointer', color: "black" }} href="/Contact_us" target="blank">
              Contact Us
            </a>
          </MenuItem>


        </Menu>
        {icons.map((Icon, i) => (
          <Button
            key={i}
            sx={{
              my: 2,
              display: "block",
              paddingLeft: 0,
              paddingRight: 0,
              minWidth: "2.5rem",

            }}
            hidden={getisEmp() === "true"}
            onClick={handleSubMenuClick.bind(null, i)}
          >
            <Icon width="1.25rem" />
          </Button>
        ))}
      </Box>







      <Box sx={{ flexGrow: 0, marginLeft: "10px" }}>
        <Tooltip title="Open settings">
          <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
            <Avatar > {name ? name[0][0] : email[0]}</Avatar >
          </IconButton>
        </Tooltip>
        <Menu
          sx={{ mt: "45px" }}
          id="menu-appbar"
          anchorEl={anchorElUser}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(anchorElUser)}
          onClose={handleCloseUserMenu}
        >
          <Box

            sx={{
              width: "auto",

              paddingLeft: "10px",
              paddingRight: "10px",
              "& hr": { mx: 0.5 },

            }}
          >
            <Stack direction="row" spacing={2}>
              <Avatar sx={{ width: 44, height: 44, }}>
                {name ? name[0][0] : email[0]}
              </Avatar>

              <div>
                <a style={{ fontSize: "16px", color: "#101828", marginLeft: 1, fontWeight: "600", marginBottom: "5px" }}>
                  {name}
                </a>
                <br />
                <a style={{ color: "#667085" }}>{email == "null" ? "" : email}</a>
              </div>
            </Stack>

          </Box>
          <hr />
          <Box sx={{
            paddingLeft: "10px",
            paddingRight: "10px",
          }} >
            <a style={{ color: "#667085", cursor: "pointer", marginBottom: "10px", textDecoration: "none", display: getisEmp() === "true" ? "none" : "" }} href="/MyAccount" ><PersonOutlineOutlinedIcon /> My Account</a><br hidden={getisEmp() === "true"} />
            <a style={{ color: "#667085", cursor: "pointer", marginBottom: "10px", textDecoration: "none", display: getOrgType() == "Admin" || getisEmp() === "true" || HasScreenPermissions("SubscriptionFeePaymentHistory") ? "none" : "" }} href="/SubscriptionFeePaymentHistory" ><CardMembershipIcon /> {"Subscription Fee"}</a><br hidden={getOrgType() == "Admin" || getisEmp() === "true" || HasScreenPermissions("SubscriptionFeePaymentHistory")} />
            <a style={{ color: "#667085", cursor: "pointer", marginBottom: "10px", textDecoration: "none", display: getOrgType() == "Admin" || getisEmp() === "true" ? "none" : "" }} href="/Notification" ><NotificationsNoneIcon /> {t("Dashboard.notifications")}</a><br hidden={getOrgType() == "Admin" || getisEmp() === "true"} />
            <a style={{ color: "#667085", cursor: "pointer", marginBottom: "10px", textDecoration: "none" }} href="/Help" ><HelpOutlineIcon /> Help</a>

            {userSettings.map((setting, i) => (
              < div style={{
                textAlign: "left"
                , marginTop: "5px"
              }} key={i}> <a onClick={setting.onClick || handleCloseUserMenu} variant="outlined" style={{ color: "#EE3F3F", cursor: "pointer" }}><LogoutIcon /> {setting.text}</a></div>
            ))}
          </Box>
        </Menu>
      </Box>
    </Toolbar>
  );
};